<template>
  <div>
    <div>
      <img
        class="mainBackImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/pilotService/planQueryBackImg.jpg')
            : require('@/assets/images/pilotService/en_planQueryBackImg.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="20" :lg="18" :xl="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in tabData"
          :key="index"
          :label="item.label"
          :name="item.name"
        >
          <el-row :gutter="0" type="flex" justify="center">
            <el-col :xs="22" :sm="22" :md="18">
              <div class="contentBox">
                <plan-table
                  :name="item.name"
                  :listQuery="listQuery"
                  :tableData="tableData"
                  :totalNum="totalNum"
                  :loading="loading"
                  @dateChange="dateChange"
                />
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  getTheoryPlan,
  getAircraftPlan,
  getOtherPlan,
} from "@/api/pilotService/plan";
import planTable from "./planTable.vue";

import { routeName, routePath } from "@/utils/index";

export default {
  components: { planTable },
  data() {
    return {
      language: localStorage.getItem("language") || "zh",
      activeName: "first",
      loading: true,
      listQuery: {
        page: 1,
        size: 10,
        date: `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${new Date()
          .getDate()
          .toString()
          .padStart(2, "0")}`,
      },
      tableData: [],
      totalNum: 0,
      tabData: [
        { name: "first", label: this.$t("pilotService.simulator") },
        { name: "second", label: this.$t("pilotService.Theoretical") },
      ],
      pathName: routeName(this.$route.name),
    };
  },
  created() {
    this.setAciveName();
  },
  watch: {
    $route: "setAciveName",
  },
  methods: {
    setAciveName() {
      const pathName = routeName(this.$route.name);
      this.pathName = pathName;
      this.activeName = this.pathName === "second" ? this.pathName : "first";
      this.load();
    },
    getApi() {
      const type = {
        first: { name: "模拟机计划", api: getAircraftPlan },
        second: { name: "理论计划", api: getTheoryPlan },
      };
      return type[this.activeName];
    },
    load() {
      const { api } = this.getApi();
      api(this.listQuery)
        .then((res) => {
          if (res.code === 0) {
            this.loading = false;
            this.tableData = res.data;
            // this.totalNum=res.data
          }
        })
        .catch((err) => {
          this.loading = false;
          // ;
        });
    },
    dateChange() {
      this.load();
    },
    handleClick(tab, event) {
      this.load();
    },
  },
};
</script>

<style scoped>
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.mainBackImg {
  width: 100%;
  /* height: 300px; */
}
.container {
  padding: 20px;
  margin: 0 auto;
}
.container /deep/ .el-tabs__header {
  /* width: 40%; */
  /* margin: 0 45%; */
  width: auto;
  margin: 0 auto;
  padding: 30px;
  display: table;
  position: inherit;
}
.container /deep/.el-tabs__nav-wrap::after {
  background: none !important;
}
.container /deep/.el-tabs__item {
  font-size: 16px;
  padding: 0 20px;
}
.container /deep/.el-tabs__item:nth-last-child(1) {
  padding-left: 9vw;
}
.container /deep/.el-tabs__item.is-active {
  font-weight: 800;
  font-size: 18px;
  color: #32589f;
}
.container /deep/.el-tabs__active-bar {
  background-color: #32589f;
  height: 6px;
  border-radius: 20px;
}
.contentBox {
  /* background-color: hsl(0, 1%, 97%); */
  background-color: #f9f9f9;
  padding: 25px;
  margin: 0 auto;
}
@media only screen and (max-width: 768px) {
  .container {
    padding: 0px;
    margin: 0 auto;
  }
  .container /deep/ .el-tabs__header {
    /* width: 50%; */
    /* margin: 0 auto; */
    padding: 15px;
  }
  .contentBox {
    width: auto;
    padding: 10px 10px;
    margin: 0 auto;
  }
  .el-range-editor.el-input__inner {
    width: 70%;
  }
}
</style>